<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
    </div>
    
    <div class="header-menu">
        <a class="app-logo">
            <img src="assets/layout/images/logo.png" alt="Logo" class="app-logo-normal">
        </a>
    </div>

    <div class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>
